import { ReactNode } from 'react';
import type { InvoicePreview } from '../../types';
import InvoicePreviewCard from './InvoicePreviewCard';

type InvoicePreviewProps = {
  header: ReactNode;
  nextInvoices: InvoicePreview[];
  onEdit?: () => void;
};

export default function InvoicePreview({ header, nextInvoices, onEdit }: InvoicePreviewProps) {
  return (
    <div className="bg-purple-50 p-6">
      <div className="mb-6 text-base">{header}</div>
      <div className="grid grid-cols-3 gap-2">
        {nextInvoices.map((invoice, index) => (
          <InvoicePreviewCard
            key={`${invoice.label}-${index}`}
            {...invoice}
            onEdit={invoice.isProrated ? onEdit : undefined}
          />
        ))}
      </div>
    </div>
  );
}
